/**
 * Utility functions for saving and loading level data using localStorage
 * with the "rexandchip_" prefix to avoid conflicts with other games.
 */
/**
 * Saves level data to localStorage.
 * @param levelIndex The index of the level.
 * @param data The data to save (completed status and optional best time).
 */
export function saveLevelData(levelIndex, data) {
    const key = `rexandchip_level_${levelIndex}`;
    localStorage.setItem(key, JSON.stringify(data));
}
/**
 * Loads level data from localStorage.
 * @param levelIndex The index of the level.
 * @returns The level data if found, otherwise null.
 */
export function loadLevelData(levelIndex) {
    const key = `rexandchip_level_${levelIndex}`;
    const data = localStorage.getItem(key);
    if (data) {
        return JSON.parse(data);
    }
    return null;
}
